import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[validDays]'
})
export class ValidDaysDirective {

  constructor(private control: NgControl) {}

  @HostListener('blur', ['$event'])
  onInput(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const rawValue = inputElement.value;

    if (rawValue === '') {
      return;
    }

    const numericValue = Number(rawValue);

    if (isNaN(numericValue)) {
      return;
    }

    if (numericValue < 1) {
      this.control.control.setValue(1);
    } else if (numericValue > 31) {
      this.control.control.setValue(31);
    }
  }

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    const allowedKeys = /[0-9]/;
    if (!allowedKeys.test(event.key)) {
      event.preventDefault();
    }
  }
}
